import { Typography } from '@mui/material';

import {
  FindingBody,
  FindingOrdinal,
  FindingRow,
  FindingsListRoot,
} from './FindingsList.styled';

export interface Finding {
  text: string;
  subline?: string;
}

export interface FindingsListProps {
  findings: Finding[];
}

function ordinalFor(index: number): string {
  return String(index + 1).padStart(2, '0');
}

export function FindingsList({ findings }: FindingsListProps) {
  if (findings.length === 0) {
    return null;
  }

  return (
    <FindingsListRoot data-testid="findings-list">
      {findings.map((finding, index) => (
        <FindingRow key={index} data-testid="finding-item">
          <FindingOrdinal data-testid="finding-ordinal">{ordinalFor(index)}</FindingOrdinal>
          <FindingBody>
            <Typography
              variant="body1"
              component="p"
              data-testid="finding-text"
              sx={{ fontWeight: 700 }}
            >
              {finding.text}
            </Typography>
            {finding.subline ? (
              <Typography
                variant="body1"
                component="p"
                color="text.secondary"
                data-testid="finding-subline"
              >
                {finding.subline}
              </Typography>
            ) : null}
          </FindingBody>
        </FindingRow>
      ))}
    </FindingsListRoot>
  );
}
